import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29.442",
  height: "29.442"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7911",
  d: "M15.957 2a13.971 13.971 0 1 0 13.985 13.971A13.964 13.964 0 0 0 15.957 2zm9.682 8.382h-4.122a21.863 21.863 0 0 0-1.928-4.974 11.218 11.218 0 0 1 6.05 4.974zM15.971 4.85a19.68 19.68 0 0 1 2.668 5.532H13.3a19.68 19.68 0 0 1 2.671-5.532zM5.157 18.765a10.928 10.928 0 0 1 0-5.588H9.88a23.073 23.073 0 0 0-.2 2.794 23.073 23.073 0 0 0 .2 2.794zM6.3 21.559h4.121a21.863 21.863 0 0 0 1.928 4.974A11.158 11.158 0 0 1 6.3 21.559zm4.121-11.177H6.3a11.158 11.158 0 0 1 6.049-4.974 21.863 21.863 0 0 0-1.928 4.974zm5.546 16.709a19.68 19.68 0 0 1-2.667-5.532h5.337a19.68 19.68 0 0 1-2.666 5.533zm3.269-8.327H12.7a20.555 20.555 0 0 1-.224-2.794 20.376 20.376 0 0 1 .224-2.794h6.54a20.376 20.376 0 0 1 .224 2.794 20.555 20.555 0 0 1-.224 2.795zm.349 7.768a21.863 21.863 0 0 0 1.928-4.974h4.121a11.218 11.218 0 0 1-6.045 4.975zm2.473-7.768a23.074 23.074 0 0 0 .2-2.794 23.074 23.074 0 0 0-.2-2.794h4.722a10.928 10.928 0 0 1 0 5.588z",
  transform: "translate(-1.25 -1.25)",
  style: {"fill":"#fff","stroke":"#2d3032","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };